"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeofenceEventStatus = exports.getEquipmentRef = exports.AlertType = exports.DocumentTitle = exports.RateTypes = exports.UAEState = exports.EmissionClass = exports.MeterLookup = exports.StationaryEquipmentTypes = exports.EquipmentType = void 0;
var EquipmentType;
(function (EquipmentType) {
    EquipmentType["AllMachines"] = "all machines";
    EquipmentType["AirCompressor"] = "air compressor";
    EquipmentType["AllTerrainCrane"] = "all terrain crane";
    EquipmentType["AngleGrinder"] = "angle grinder";
    EquipmentType["ArcWeldingMachine"] = "arc welding machine";
    EquipmentType["ArticulatedDumpTruck"] = "articulated dump truck";
    EquipmentType["AsphaltPaverMachine"] = "asphalt paver machine";
    EquipmentType["AsphaltSawCutter"] = "asphalt saw cutter";
    EquipmentType["AsphaltTeam"] = "asphalt team";
    EquipmentType["BackhoeLoader"] = "backhoe loader";
    EquipmentType["BitumenTanker"] = "bitumen tanker";
    EquipmentType["BoomLift"] = "boom lift";
    EquipmentType["BoomLoader"] = "boom loader";
    EquipmentType["BoomTruck"] = "boom truck";
    EquipmentType["BoomTruckWinch"] = "boom truck winch";
    EquipmentType["BoxTruck"] = "box truck";
    EquipmentType["Bulldozer"] = "bulldozer";
    EquipmentType["BundlePuller"] = "bundle puller";
    EquipmentType["Bus"] = "bus";
    EquipmentType["ChainSaw"] = "chain saw";
    EquipmentType["CementMixer"] = "cement mixer";
    EquipmentType["CngSkid"] = "cng skid";
    EquipmentType["ConcretePolishingMachine"] = "concrete polishing machine";
    EquipmentType["ConcretePump"] = "concrete pump";
    EquipmentType["ConcreteVibratorElectric"] = "concrete vibrator electric";
    EquipmentType["ConcreteVibratorPetrol"] = "concrete vibrator petrol";
    EquipmentType["ConstructionBarge"] = "construction barge";
    EquipmentType["CrawlerCrane"] = "crawler crane";
    EquipmentType["DieselTanker"] = "diesel tanker";
    EquipmentType["DoubleDrumRoller"] = "double drum roller";
    EquipmentType["DrillingRig"] = "drilling rig";
    EquipmentType["DumpTruck"] = "dump truck";
    EquipmentType["ExcavatorAttachment"] = "excavator attachment";
    EquipmentType["ExcavatorCrawler"] = "excavator crawler";
    EquipmentType["ExcavatorCrawlerJackhammer"] = "excavator crawler jackhammer";
    EquipmentType["ExcavatorLongBoom"] = "excavator long boom";
    EquipmentType["ExcavatorWheel"] = "excavator wheel";
    EquipmentType["FlatTopBarge"] = "flat top barge";
    EquipmentType["Forklift"] = "forklift";
    EquipmentType["Generator"] = "generator";
    EquipmentType["GroutingMachine"] = "grouting machine";
    EquipmentType["HiabCrane"] = "hiab crane";
    EquipmentType["IndustrialVaccumCleaner"] = "industrial vaccum cleaner";
    EquipmentType["JackHammer"] = "jack hammer";
    EquipmentType["JigSaw"] = "jig saw";
    EquipmentType["LaserScanner"] = "laser scanner";
    EquipmentType["LiftingCradle"] = "lifting cradle";
    EquipmentType["LightingTower"] = "lighting tower";
    EquipmentType["Loadbank"] = "loadbank";
    EquipmentType["Lowbed"] = "lowbed";
    EquipmentType["Flatbed"] = "flatbed";
    EquipmentType["ManLift"] = "man lift";
    EquipmentType["MarbleCutter"] = "marble cutter";
    EquipmentType["MillingMachine"] = "milling machine";
    EquipmentType["MixokretMachine"] = "mixokret machine";
    EquipmentType["MobileTireCrane"] = "mobile tire crane";
    EquipmentType["MobileRockCrusher"] = "mobile rock crusher";
    EquipmentType["MotorCycle"] = "motor cycle";
    EquipmentType["MotorGrader"] = "motor grader";
    EquipmentType["OverHeadCrane"] = "over head crane";
    EquipmentType["PickupTruck"] = "pickup truck";
    EquipmentType["PipeLayer"] = "pipelayer";
    EquipmentType["PiilingMachine"] = "piling machine";
    EquipmentType["PlasteringMachine"] = "plastering Machine";
    EquipmentType["PlateCompactor"] = "plate compactor";
    EquipmentType["PneumaticTyredRoller"] = "pneumatic tyred roller";
    EquipmentType["PowerPalletTruck"] = "power pallet truck";
    EquipmentType["PowerTower"] = "power tower";
    EquipmentType["PowerTrowel"] = "power trowel";
    EquipmentType["PprMachine"] = "ppr machine";
    EquipmentType["PushBarge"] = "push barge";
    EquipmentType["ReachTruck"] = "reach truck";
    EquipmentType["RecoveryTruck"] = "recovery truck";
    EquipmentType["RefrigeratedTruck"] = "refrigerated truck";
    EquipmentType["RefrigeratedVan"] = "refrigerated van";
    EquipmentType["RigidTruck"] = "rigid truck";
    EquipmentType["RideOnRoller"] = "ride on roller";
    EquipmentType["RideOnScrubber"] = "ride on scrubber";
    EquipmentType["RoughTerrainCrane"] = "rough terrain crane";
    EquipmentType["ScissorLift"] = "scissor lift";
    EquipmentType["SingleDrumRoller"] = "single drum roller";
    EquipmentType["SkidSteerLoader"] = "skid steer loader";
    EquipmentType["SkipLoader"] = "skip loader";
    EquipmentType["SpiderCrane"] = "spider crane";
    EquipmentType["SpiderLift"] = "spider lift";
    EquipmentType["Stabilizer"] = "stabilizer";
    EquipmentType["Stacker"] = "stacker";
    EquipmentType["StationaryConcretePump"] = "stationary concrete pump";
    EquipmentType["StationaryFuelTank"] = "stationary fuel tank";
    EquipmentType["SubmersiblePump"] = "submersible pump";
    EquipmentType["SuperSucker"] = "super sucker";
    EquipmentType["SweetWaterTanker"] = "sweet water tanker";
    EquipmentType["Trailer"] = "trailer";
    EquipmentType["Trencher"] = "trencher";
    EquipmentType["TruckMountedManLift"] = "truck mounted man lift";
    EquipmentType["TugBoat"] = "tug boat";
    EquipmentType["WalkBehindCompactor"] = "walk behind compactor";
    EquipmentType["WasteWaterTanker"] = "waste water tanker";
    EquipmentType["WaterTanker"] = "water tanker";
    EquipmentType["VaccumTanker"] = "vaccum tanker";
    EquipmentType["Van"] = "van";
    EquipmentType["VerticalLift"] = "vertical lift";
    EquipmentType["WheelLoaderShovel"] = "wheel loader shovel";
    EquipmentType["TowerCrane"] = "tower crane";
    EquipmentType["HarbourTowerCrane"] = "harbour tower crane";
    EquipmentType["TruckMountedCrane"] = "truck mounted crane";
    EquipmentType["TerminalTractor"] = "terminal tractor";
    EquipmentType["EmptyContainerHandler"] = "empty container handler";
    EquipmentType["QuayCrane"] = "quay crane";
    EquipmentType["BathTappingVehicle"] = "bath tapping vehicle";
    EquipmentType["Tractor"] = "tractor";
    EquipmentType["Bike"] = "bike";
    EquipmentType["SprayTanker"] = "spray tanker";
    EquipmentType["Yacht"] = "yacht";
    EquipmentType["RubberTyreGantryCrane"] = "rubber tyre gantry crane";
    EquipmentType["MobileFeeder"] = "mobile feeder";
    EquipmentType["FireFightingTruck"] = "fire fighting truck";
})(EquipmentType = exports.EquipmentType || (exports.EquipmentType = {}));
exports.StationaryEquipmentTypes = {
    [EquipmentType.Generator]: true,
    [EquipmentType.Loadbank]: true,
    [EquipmentType.PowerTower]: true,
    [EquipmentType.Stabilizer]: true,
    [EquipmentType.SubmersiblePump]: true,
    [EquipmentType.SuperSucker]: true,
    [EquipmentType.StationaryConcretePump]: true,
    [EquipmentType.StationaryFuelTank]: true,
    [EquipmentType.SpiderLift]: true,
    [EquipmentType.JackHammer]: true,
    [EquipmentType.JigSaw]: true,
    [EquipmentType.ChainSaw]: true,
    [EquipmentType.AirCompressor]: true,
    [EquipmentType.AngleGrinder]: true,
    [EquipmentType.ArcWeldingMachine]: true,
    [EquipmentType.AsphaltSawCutter]: true,
    [EquipmentType.BundlePuller]: true,
    [EquipmentType.ConcretePolishingMachine]: true,
    [EquipmentType.ConcreteVibratorElectric]: true,
    [EquipmentType.ConcreteVibratorPetrol]: true,
    [EquipmentType.GroutingMachine]: true,
    [EquipmentType.DrillingRig]: true,
    [EquipmentType.LaserScanner]: true,
    [EquipmentType.IndustrialVaccumCleaner]: true,
    [EquipmentType.LightingTower]: true,
    [EquipmentType.LiftingCradle]: true,
    [EquipmentType.MarbleCutter]: true,
    [EquipmentType.MobileRockCrusher]: true,
    [EquipmentType.OverHeadCrane]: true,
    [EquipmentType.QuayCrane]: true,
    [EquipmentType.HarbourTowerCrane]: true,
};
exports.MeterLookup = {
    [EquipmentType.Generator]: {
        hourmeter: true,
        odometer: false
    },
    [EquipmentType.ArcWeldingMachine]: {
        hourmeter: true,
        odometer: false
    },
    [EquipmentType.AirCompressor]: {
        hourmeter: true,
        odometer: false
    },
    [EquipmentType.DumpTruck]: {
        hourmeter: false,
        odometer: true
    },
    [EquipmentType.ArticulatedDumpTruck]: {
        hourmeter: false,
        odometer: true
    },
    [EquipmentType.Van]: {
        hourmeter: false,
        odometer: true
    },
    [EquipmentType.Bus]: {
        hourmeter: false,
        odometer: true
    },
    [EquipmentType.DieselTanker]: {
        hourmeter: false,
        odometer: true
    },
    [EquipmentType.EmptyContainerHandler]: {
        hourmeter: true,
        odometer: false
    },
    [EquipmentType.FireFightingTruck]: {
        hourmeter: false,
        odometer: true
    },
    [EquipmentType.Forklift]: {
        hourmeter: true,
        odometer: false
    },
    [EquipmentType.HarbourTowerCrane]: {
        hourmeter: true,
        odometer: false
    },
    [EquipmentType.MobileTireCrane]: {
        hourmeter: true,
        odometer: true
    },
    [EquipmentType.TruckMountedCrane]: {
        hourmeter: true,
        odometer: true
    },
    [EquipmentType.QuayCrane]: {
        hourmeter: true,
        odometer: false
    },
    [EquipmentType.RecoveryTruck]: {
        hourmeter: false,
        odometer: true
    },
    [EquipmentType.SkidSteerLoader]: {
        hourmeter: true,
        odometer: false
    },
    [EquipmentType.Stacker]: {
        hourmeter: true,
        odometer: false
    },
    [EquipmentType.TerminalTractor]: {
        hourmeter: true,
        odometer: false
    },
};
var EmissionClass;
(function (EmissionClass) {
    EmissionClass["StageIIIA"] = "StageIIIA";
    EmissionClass["StageIIIB"] = "StageIIIB";
    EmissionClass["StageIV"] = "StageIV";
    EmissionClass["StageV"] = "StageV";
    EmissionClass["Hybride"] = "Hybride";
    EmissionClass["Elektrisch"] = "Elektrisch";
})(EmissionClass = exports.EmissionClass || (exports.EmissionClass = {}));
var UAEState;
(function (UAEState) {
    UAEState["DXB"] = "DXB";
    UAEState["AUH"] = "AUH";
    UAEState["SHJ"] = "SHJ";
    UAEState["RAK"] = "RAK";
    UAEState["AJM"] = "AJM";
    UAEState["FUJ"] = "FUJ";
    UAEState["UAQ"] = "UAQ";
})(UAEState = exports.UAEState || (exports.UAEState = {}));
var RateTypes;
(function (RateTypes) {
    RateTypes["Monthly"] = "monthly";
    RateTypes["MonthlyNightShift"] = "monthly - night shift";
    RateTypes["Daily"] = "daily";
    RateTypes["DailyNightShift"] = "daily - night shift";
    RateTypes["Weekly"] = "weekly";
    RateTypes["WeeklyNightShift"] = "weekly - night shift";
    RateTypes["Trips"] = "trips";
})(RateTypes = exports.RateTypes || (exports.RateTypes = {}));
var DocumentTitle;
(function (DocumentTitle) {
    DocumentTitle["MULKIYA"] = "MULKIYA";
    DocumentTitle["MULKIYA_FRONT"] = "MULKIYA_FRONT";
    DocumentTitle["MULKIYA_BACK"] = "MULKIYA_BACK";
    DocumentTitle["INSURANCE"] = "INSURANCE";
    DocumentTitle["THIRD_PARTY_CERTIFICATE"] = "THIRD_PARTY_CERTIFICATE";
    DocumentTitle["GENERAL_IMAGE"] = "GENERAL_IMAGE";
    DocumentTitle["GENERAL_IMAGE_FRONT"] = "GENERAL_IMAGE_FRONT";
    DocumentTitle["GENERAL_IMAGE_BACK"] = "GENERAL_IMAGE_BACK";
    DocumentTitle["GENERAL_IMAGE_LEFT"] = "GENERAL_IMAGE_LEFT";
    DocumentTitle["GENERAL_IMAGE_RIGHT"] = "GENERAL_IMAGE_RIGHT";
    DocumentTitle["GENERAL_IMAGE_ISOMETRIC"] = "GENERAL_IMAGE_ISOMETRIC";
    DocumentTitle["PLACEHOLDER_IMAGE"] = "PLACEHOLDER_IMAGE";
    DocumentTitle["PASSPORT"] = "PASSPORT";
    DocumentTitle["VISA"] = "VISA";
    DocumentTitle["RESIDENCE_ID"] = "RESIDENCE_ID";
    DocumentTitle["DRIVING_LICENSE"] = "DRIVING_LICENSE";
    DocumentTitle["TRADE_LICENSE"] = "TRADE_LICENSE";
    DocumentTitle["VAT_CERTIFICATE"] = "VAT_CERTIFICATE";
    DocumentTitle["VEHICLE_LIST"] = "VEHICLE_LIST";
    DocumentTitle["PRE_MOB_INSPECTION"] = "PRE_MOB_INSPECTION";
})(DocumentTitle = exports.DocumentTitle || (exports.DocumentTitle = {}));
var AlertType;
(function (AlertType) {
    AlertType["Geofence"] = "geofence";
    AlertType["Idle"] = "idle";
    AlertType["Expiry"] = "expiry";
})(AlertType = exports.AlertType || (exports.AlertType = {}));
const getEquipmentRef = (id, equipment) => {
    return {
        id,
        label: `${equipment.model} - ${equipment.number_plate.raw}`,
    };
};
exports.getEquipmentRef = getEquipmentRef;
var GeofenceEventStatus;
(function (GeofenceEventStatus) {
    GeofenceEventStatus["Entered"] = "Entered";
    GeofenceEventStatus["Exited"] = "Exited";
})(GeofenceEventStatus = exports.GeofenceEventStatus || (exports.GeofenceEventStatus = {}));
// Queries:
// 1. All the machines under a project
// 2. All the machines owned by a supplier
// 3. All machines managed by a contractor
// 4. All machines in a particular yard
// 5. All projects by a user who has access to
// 6. All projects under an contractor account
// 7. All yards under a supplier/contractor account
// 8. All active machines under a project
// 9. Timesheet data for a machine for a date range
//# sourceMappingURL=equipment.js.map